import React, { useContext, PropsWithChildren } from "react";
import { ListContext, IntlContext } from "context";

const BulkActions: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    const listContext = useContext(ListContext);
    const intl = useContext(IntlContext);

    return (
        <div className={`crud-bulk-actions ${listContext.selectedIds.length ? "crud-bulk-actions--open" : ""}`}>
            <div className="crud-bulk-actions__info has-actions">{children}</div>
            <div className="crud-bulk-actions__info">
                {intl.formatMessage("generic.crud.bulk_actions.selected_item_count.label", {
                    selected_items_count: listContext.selectedIds.length,
                })}
            </div>
        </div>
    );
};

export default BulkActions;
